import React from "react";
import "@/App.css";
import { Navigation } from "./components/sections/Navigation";
import { HeroSection } from "./components/sections/HeroSection";
import { AboutSection } from "./components/sections/AboutSection";
import { ProductsSection } from "./components/sections/ProductsSection";
import { SolutionsSection } from "./components/sections/SolutionsSection";
import { PartnersSection } from "./components/sections/PartnersSection";
import { GallerySection } from "./components/sections/GallerySection";
import { ContactSection } from "./components/sections/ContactSection";
import { Footer } from "./components/sections/Footer";
import { WhatsAppButton } from "./components/sections/WhatsAppButton";

function App() {
  return (
    <div className="App">
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <ProductsSection />
        <SolutionsSection />
        <PartnersSection />
        <GallerySection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
